import { UploadStatus } from '@src/types/files-upload-types';
import { useState } from 'react';

interface UseFileUploadProps {
  onUploadStatusChange: (status: UploadStatus) => void;
}

export const useFileUpload = ({ onUploadStatusChange }: UseFileUploadProps) => {
  const [file, setFile] = useState<File | null>(null);

  const handleFileSelection = (selectedFiles: FileList | null) => {
    onUploadStatusChange('uploading');
    setFile(null);

    const selectedFile = selectedFiles?.[0];
    if (!selectedFile) {
      onUploadStatusChange('idle');
      return;
    }

    setFile(selectedFile);
    onUploadStatusChange('success');
  };

  const handleRemoveFile = () => {
    setFile(null);
    onUploadStatusChange('idle');
  };

  return {
    file,
    handleFileSelection,
    handleRemoveFile,
  };
};
